import styled from 'styled-components';

interface IStyledField {
  $isChild?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 100%;
  min-width: 0;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors?.text?.primary ?? theme.colors?.gray01};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-weight: 600;
`;

export const DivSelect = styled.div<{ $disabled?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: max-content;
  min-width: 100%;
  min-height: 4.3rem;
  padding: 0 1rem;
  border-radius: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  color: ${({ theme }) => theme.colors?.text?.primary};
  background-color: ${({ theme }) => theme.colors?.gray02};
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  box-shadow: inset 0 3px 6px ${({ theme }) => theme.colors?.gray04};
`;

export const DivGeneral = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  min-width: 100%;
  width: max-content;
  max-width: min(90vw, 960px);
  max-height: 400px;
  overflow: auto;
  padding: 0.75rem 1.75rem 0.75rem 0.75rem;
  scrollbar-gutter: stable;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  box-shadow: 0 6px 16px ${({ theme }) => theme.colors?.black01};
`;

export const DivGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  min-width: 100%;
  margin-bottom: 0.35rem;
`;

export const DivGroupNested = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  min-width: 100%;
  padding-left: 0.25rem;
  margin-left: 0.75rem;
`;

export const DivInput = styled.div<IStyledField>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: max-content;
  min-width: 100%;
  padding: 0.65rem 2rem 0.65rem 0.75rem;
  border-radius: 6px;
  box-sizing: border-box;
  white-space: nowrap;

  ${({ $isChild }) =>
    $isChild &&
    `
    padding-left: 1.25rem;
  `}

  &:hover {
    background-color: ${({ theme }) => theme.colors?.primary};
  }
`;

export const CheckboxInput = styled.input`
  pointer-events: none;
  flex-shrink: 0;
`;

export const OptionTitle = styled.span<{ $isBold?: boolean }>`
  flex: 1 1 auto;
  min-width: max-content;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: ${({ $isBold }) => ($isBold ? 700 : 400)};

  &:hover {
    color: ${({ theme }) => theme.colors?.text?.tertiary};
  }
`;

export const DownIcon = styled.span`
  margin-left: auto;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors?.text?.secondary};
`;

export const SelectedLabel = styled.span`
  flex: 1;
  padding-right: 1.75rem;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;
